import script from "./ResourceLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceLightbox.vue?vue&type=script&setup=true&lang=js"

import "./ResourceLightbox.vue?vue&type=style&index=0&id=68b81118&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b81118"]])

export default __exports__